<script>
  import Icon from '../Icon.svelte';

  import {
    categories,
    nameCol,
    weightCol,
    transportCol,
    imgCol,
    linkCol,
    productShopBaseUrl,
    productImgBaseUrl
  } from '../../config';
  import { formatWeight } from '../../utils';

  export let product;
  export let isLast = false;

  $: matchingCategory = categories.find(c => c.key === product.category);
  $: bgColor = matchingCategory ? matchingCategory.minColor : '#eee';
</script>

<style>
  .km-product:first-of-type {
    padding: 0 0 5px 0;
  }

  .km-product {
    padding: 5px 0;
    display: flex;
    align-items: center;
    font-size: 13px;
  }

  .km-description {
    display: flex;
    align-items: flex-start;
  }

  .km-rank {
    margin-right: 4px;
  }

  a {
    color: #3a3a3a;
    text-decoration: none;
    letter-spacing: 0.25px;
    margin-right: 4px;
  }

  a:visited {
    color: #3a3a3a;
  }

  a:hover {
    color: #111;
    opacity: 0.5;
  }

  .km-weight {
    border-radius: 3px !important;
    color: #3a3a3a;
    padding: 4px 7px 1px 4px;
    display: inline-flex;
    align-items: center;
    top: 4px;
    position: relative;
    margin-bottom: 5px;
  }

  .km-weight :global(svg) {
    align-self: center;
    width: 22px;
    height: 18px;
    margin-right: 3px;
  }

  .km-img {
    background-repeat: no-repeat;
    width: 60px;
    height: 60px;
    background-color: white;
    background-position: center center;
    margin-left: auto;
    background-size: contain;
  }
</style>

<div
  class="km-product"
  style={`border-bottom: ${isLast ? 'none' : '1px solid #e1e1e1'}`}>

  <div class="km-description">
    <div class="km-rank">{product.rank}.</div>
    <div class="km-name">
      <a target="_blank" href="{productShopBaseUrl}{product[linkCol]}">
        {product[nameCol]}
      </a>
      {#if product[weightCol]}
        <br />
        <span class="km-weight" style="background-color: {bgColor}">
          <Icon name={product[transportCol]} />
          {formatWeight(product[weightCol])}
        </span>
      {/if}
    </div>
  </div>

  <div
    class="km-img"
    style="background-image: url('{productImgBaseUrl}{product[imgCol]}');" />
</div>
